import * as d3 from 'd3';

export function addIcons(map, layer, icons, rotation) {

  map = d3.select(map);

  // Add layer
  const group = map.append('g').attr('id', layer);
  if(layer=='route'){
    addDot(group, icons);
  }else{
    addIcon(group, icons, rotation);
  }
}

function addIcon(layer, data, rotation) {
  const nodes = layer.selectAll('.icon')
    .data(data)
    .enter()
    .append('g')
    .attr('class', d => `${d.class} icon`)
    .attr('transform', d => `translate(${d.x} ${d.y}) rotate(${d.rotation ? d.rotation : (-1 * rotation)})`)
    .attr('id', d => `${d.id}`);
  addAnim(nodes);
  addBase(nodes);
  add(nodes);
}

function addDot(layer, data){
  layer.selectAll('.circle')
    .data(data)
    .enter()
    .append('circle')
    .attr('class', 'routemark')
    .attr('r', d => `${d.width}`)
    .attr('fill', '#1EBCFF')
    .attr('stroke-width', 1)
    .attr('transform', d => `translate(${d.x} ${d.y})`);
}

function add(nodes){
  nodes
    .append('use')
    .attr('xlink:href', d => `${d.path}`)
    .attr('href', d => `${d.path}`)
    .attr('width', d => `${d.width}`)
    .attr('height', d => `${d.height}`)
    .attr('class', d => `${d.class}`)
    .attr('id', d => `${d.id}`)
    .attr('transform', d => d.customTranslate ?
      `translate(${d.customTranslate.x} ${d.customTranslate.y})` :
      `translate(-${d.width/2} -${d.height/2})`);
}

function addBase(nodes){
  nodes
    .filter(d => d.base)
    .append('use')
    .attr('xlink:href', d => `${d.base.path}`)
    .attr('href', d => `${d.base.path}`)
    .attr('width', d => `${d.base.width}`)
    .attr('height', d => `${d.base.height}`)
    .attr('transform', d => d.customTranslate ?
      `translate(${d.customTranslate.x} ${d.customTranslate.y})` :
      `translate(-${d.base.width/2} -${d.base.height/2})`);
}

function addAnim(nodes){

  const g = nodes
    .append('g')
    .attr('class', 'anim-pulse anim-pulse--instant');
  g.append('circle').attr('class', 'anim-pulse__ring');
  g.append('circle').attr('class', 'anim-pulse__ring');
  g.append('circle').attr('class', 'anim-pulse__ring');
}
